import script from "./AnnotateStudio.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnotateStudio.vue?vue&type=script&setup=true&lang=js"

import "./AnnotateStudio.vue?vue&type=style&index=0&id=79ecfada&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ecfada"]])

export default __exports__